import { InformationIcon } from 'components/icons';
import { Tooltip } from 'components/ui';
import querystring from 'querystring';
import { useHistory } from 'react-router-dom';
import { useParseURLQueryParams } from 'utils';
/**
 *
 * @param {*} param0
 * @returns
 */
export default function LinkToSegmentCell({ value, row }) {
  const { rawQueryParams } = useParseURLQueryParams();

  const history = useHistory();

  const handleClick = () => {
    history.push({
      pathname: '/customers/create',
      search: querystring.stringify({
        store_name: rawQueryParams.store_name,
        segment_name: row.original.segment_name,
      }),
    });
  };

  return (
    <div className="flex items-center space-x-0.5">
      <button onClick={handleClick}>
        <p className="font-bold text-left hover:text-segments-link overflow-wrap-anywhere">
          {String(value)}
        </p>
      </button>
      <Tooltip text={row.original.description}>
        <div className=" hover:bg-segments-gray rounded p-0.5">
          <InformationIcon className="w-4 h-4 opacity-50" />
        </div>
      </Tooltip>
    </div>
  );
}
